export const ONLY_RU_COUNTRY = "ONLY_RU_COUNTRY";
export const FRIENDLY_COUNTRY = "FRIENDLY_COUNTRY";
export const ALL_COUNTRY = "ALL_COUNTRY";
export const RU = 'RU';
export const TJ = 'TJ';
export const KZ = 'KZ';
export const UZ = 'UZ';

export const M = 'M';
export const F = 'F';

export const PS = 'PS';
export const SR = 'SR';
export const PSP = 'PSP';
export const NP = 'NP';

// ID card и свидетельство о рождении на внутренних рейсах. Значения живут только
// внутри формы: на бэкенд оба уходят как NP (см. getApiDocumentType).
export const NP_ID = 'NP_ID';
export const NP_SR = 'NP_SR';

export const ALL_DOCUMENTS_ITEMS = [NP, PS, SR, PSP];

// Страны, где на внутренних рейсах принимают ID card, а детям — свидетельство о рождении.
// Режим определяется странами маршрута, а не страной сайта, поэтому список одинаков везде.
export const DOMESTIC_DOCS_COUNTRIES = [UZ, KZ, TJ];
